import React from 'react'

class ChunkErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  componentDidCatch(error) {
    if (error.name === 'ChunkLoadError' || /Loading chunk \d+ failed/.test(error.message)) {
      window.location.reload()
    }
  }

  render() {
    if (this.state.hasError) return null
    return this.props.children
  }
}

export default ChunkErrorBoundary
